import { inject, signal } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { catchError, of } from "rxjs";
import { AlertMessageService } from "../alert-msg/message.service";

export const revNotesDetailsResolver: ResolveFn<any> = (route, state) => {
  const topic_slug = signal<string>(route.paramMap.get("topic") ?? "");
  const _alertMessageService = inject(AlertMessageService);
  const _httpClient = inject(HttpClient);
  const baseUrl = environment.apiUrl;

  const request = _httpClient.get(`${baseUrl}api/website/topics/${topic_slug()}/revision-notes`).pipe(
    catchError((err) => {
      _alertMessageService.addMsg(err?.error?.msg || "Error loading sup topics data");
      return of(undefined);
    }),
  );

  return request;
};
